import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Modal } from "@material-ui/core";
import { Button } from "react-bootstrap";
import Select from "react-select";

import { savePackageToUser } from "../../actions/packages";
import "./PackageModal.scss";

class PackageModal extends React.Component {
  state = {
    name: "",
    trackingNumber: "",
    lockerID: "",
    submitErr: undefined
  };

  handleSubmit = () => {
    const { name, trackingNumber, lockerID } = this.state;
    if (
      name.length === 0 ||
      trackingNumber.length === 0 ||
      lockerID.length === 0
    ) {
      this.setState({ submitErr: "One of the above fields is empty" });
      return;
    }

    this.props.savePackageToUser(this.state);
  };

  handleChange = (stateName, value) => {
    this.setState({ [stateName]: value, submitErr: undefined });
  };

  render() {
    const pickerOptions = this.props.userData.lockers
      ? this.props.userData.lockers.map(locker => {
          return { value: locker.id, label: locker.name };
        })
      : [];

    return (
      <Modal
        id="packageModal"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <div className="modalContainer">
          <h3>Add Package</h3>
          <form onSubmit={e => e.preventDefault()}>
            <input
              className="packageInput"
              placeholder="Order Name"
              onChange={e => this.handleChange("name", e.target.value)}
            />
            <input
              className="packageInput"
              placeholder="Tracking Number"
              onChange={e =>
                this.handleChange("trackingNumber", e.target.value)
              }
            />
            <Select
              options={pickerOptions}
              placeholder="Select locker..."
              className="lockerPicker"
              onChange={locker => this.handleChange("lockerID", locker.value)}
              styles={{
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#c3c5c5"
                })
              }}
            />
            {this.state.submitErr && (
              <p className="submitErr">{this.state.submitErr}</p>
            )}
            <Button
              style={{ alignSelf: "flex-end" }}
              onClick={this.handleSubmit}
            >
              SUBMIT
            </Button>
          </form>
        </div>
      </Modal>
    );
  }
}

PackageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  savePackageToUser: state => dispatch(savePackageToUser(state))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageModal);
